import CustomPagination from 'components/CustomPagination'
import Grid from 'components/Grid'
import Layout from 'components/Layout'
import MainContentContainer from 'components/MainContentContainer'
import { useReportingPage } from 'hooks'

import { StyledContainer, StyledGridContainer, StyledPaginationContainer, ButtonsContainer } from './Reporting.styles'
import ReportingFilterDrawer from './ReportingFilterDrawer/ReportingFilterDrawer'
import { StyledAddUserButton, StyledDownloadUsersButton } from 'pages/Users/Users.styles'

const Users = () => {
  const {
    form,
    usersColumns,
    usersDataSource,
    refetch,
    count,
    limit,
    closeDrawer,
    formData,
    open,
    loading,
    handleSubmit,
    handleFormFieldChange,
    handleSelectChange,
    handleFilterClick,
    handleExportClick,
    onRowClick,
  } = useReportingPage()

  return (
    <Layout>
      <MainContentContainer pageName="Reporting">
        <StyledContainer>
          <ButtonsContainer>
            <StyledDownloadUsersButton onClick={handleExportClick} disabled={loading} style={{ marginLeft: '12px' }}>
              {loading ? 'Exporting...' : 'Export Users'}
            </StyledDownloadUsersButton>
            <StyledAddUserButton onClick={handleFilterClick} disabled={false}>
              Filter Users
            </StyledAddUserButton>
          </ButtonsContainer>
          <StyledGridContainer>
            <Grid columns={usersColumns} dataSource={usersDataSource} checkboxColumn={false} onRowClick={onRowClick} />
          </StyledGridContainer>
          <StyledPaginationContainer>
            <CustomPagination pageSize={limit} count={count} refetch={refetch} />
          </StyledPaginationContainer>
        </StyledContainer>
        <ReportingFilterDrawer
          formData={formData}
          open={open}
          closeDrawer={closeDrawer}
          loading={loading}
          handleSubmit={handleSubmit}
          handleFormFieldChange={handleFormFieldChange}
          form={form}
          handleSelectChange={handleSelectChange}
        />
      </MainContentContainer>
    </Layout>
  )
}

export default Users
